import { render } from "./DispenserGuidesTabs.vue?vue&type=template&id=6a3daec8"
import script from "./DispenserGuidesTabs.vue?vue&type=script&lang=js"
export * from "./DispenserGuidesTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/packs/components/DispenserGuidesTabs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a3daec8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a3daec8', __exports__)) {
    api.reload('6a3daec8', __exports__)
  }
  
  module.hot.accept("./DispenserGuidesTabs.vue?vue&type=template&id=6a3daec8", () => {
    api.rerender('6a3daec8', render)
  })

}


export default __exports__